export default __webpack_public_path__ + "static/media/gg.d19e08e4.svg";